module.exports = __webpack_public_path__ + "static/img/productu01.e00478d7.png";